import { PageSelect } from "./PageSelect";

export default PageSelect;
